import { StandaloneLinkProps } from '@/base/components/element/Link';
import FestisBannerDesktop from '@/hant/public/image/festis-banner-desktop.jpg';
import FestisBannerMobile from '@/hant/public/image/festis-banner-mobile.jpg';
import { standaloneComponent } from 'modules/dynamic-components';
import NextImage from 'next/image';

const Link = standaloneComponent<StandaloneLinkProps>('ElementLink');

export const HantFestisBanner = () => {
  return (
    <div className="cts-impression-group flex justify-center sm:mx-3">
      <Link
        href="https://www.hant.se/video/show/festis/T6tOAgNE"
        options={{ className: 'cts-impression-item' }}
        data-cts-label="festis-banner"
        data-cts-name="festis-banner"
        data-cts-creative="festis-banner"
        data-cts-id="festis-banner"
        content={
          <picture>
            <NextImage className="hidden sm:block" alt="Festis marknadsföring banner" src={FestisBannerDesktop} />
            <NextImage className="block sm:hidden" alt="Festis marknadsföring banner" src={FestisBannerMobile} />
          </picture>
        }
      />
    </div>
  );
};

export default HantFestisBanner;
